import React from "react";
import TextCellEditor from "./TextCellEditor";
import TextareaCellEditor from "./TextareaCellEditor";
import SelectCellEditor from "./SelectCellEditor";

function renderTextCellEditor(props) {
    return <TextCellEditor {...props} />;
}

function renderTextareaCellEditor(props) {
    return <TextareaCellEditor {...props} />;
}

function renderSelectCellEditor(props) {
    return <SelectCellEditor {...props} />;
}

export function createCellEditor(editorType) {
    switch (editorType) {
        case "text":
            return renderTextCellEditor;
        case "textarea":
            return renderTextareaCellEditor;
        case "select":
            return renderSelectCellEditor;
        default:
            return undefined;
    }
}
